import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import i18n from 'react-intl-universal';

import Modal from './Modal';
import styles from './Modal.scss';

class Open extends Component {
  static displayName = 'Modal.open';
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentWillUnmount() {
    this.props.destroy();
  }

  showModal = () => {
    this.setState((prevState) => {
      if (prevState.visible) {
        return null;
      }
      return {
        visible: true,
      };
    });
  };

  hideModal = () => {
    this.setState({ visible: false });
  };

  handleOk = (e) => {
    this.hideModal();
    const { onOk } = this.props;
    if (_.isFunction(onOk)) {
      onOk(e);
    }
  };

  handleCancel = (e) => {
    this.hideModal();
    const { onCancel } = this.props;
    if (_.isFunction(onCancel)) {
      onCancel(e);
    }
  };

  render() {
    const { content } = this.props;

    return (
      <Modal
        {...this.props}
        visible={this.state.visible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
      >
        <div className={styles['confirm-wrapper']}>
          {content}
        </div>
      </Modal>
    );
  }
}

export default function open(content, options) {
  return new Promise((resolve) => {
    let called = false;
    const div = document.createElement('div');
    document.body.appendChild(div);

    // 在关闭动画结束时，触发destroy方法
    function destroy() {
      const isRemoved = ReactDOM.unmountComponentAtNode(div);
      if (isRemoved && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    }

    const openProps = {
      ...options,
      content,
      destroy,
    };

    function ref(instance) {
      if (called) {
        return;
      }
      called = true;
      instance.showModal();
      resolve({
        destroy,
        instance,
        target: div,
      });
    }

    ReactDOM.render(<Open {...openProps} ref={ref}/>, div);
  });
}



// WEBPACK FOOTER //
// ./src/components/Modal/ModalOpen.js